/**
 * CSS da folha A4 do romaneio (impressao fiel).
 *
 * Escopado em `#romaneio-print-papers` e com cores LITERAIS (nao usa as CSS
 * vars do app) — a impressao abre numa janela limpa sem o tema do app, entao
 * a folha precisa ser preto-no-branco por conta propria. Mesma tecnica do
 * legado RevisorFerragens.
 */

export function documentoCss() {
  const S = "#romaneio-print-papers";
  return `
  ${S} { display: flex; flex-direction: column; align-items: center; }
  ${S} .rmn-paper {
    width: 210mm; min-height: 297mm; max-width: 100%; margin: 0 auto 16px;
    background: #fff; color: #15171c; padding: 16mm 16mm; box-sizing: border-box;
    box-shadow: 0 6px 24px rgba(0,0,0,.18);
    font-family: -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    font-size: 11pt; line-height: 1.45;
  }
  ${S} .rmn-paper * { box-sizing: border-box; }
  @media (max-width: 230mm) {
    ${S} .rmn-paper { width: 100%; min-height: 0; padding: 12mm; }
  }
  `;
}

/** CSS extra so para a JANELA de impressao (limpa fundo + quebra de pagina). */
export function documentoCssJanela() {
  return `
  @page { size: A4; margin: 0; }
  html, body { margin: 0; background: #fff; }
  #romaneio-print-papers .rmn-paper {
    box-shadow: none !important; margin: 0 auto !important;
    width: 210mm; min-height: 297mm; padding: 16mm; box-sizing: border-box;
    color: #15171c; font-size: 11pt; line-height: 1.45;
    font-family: -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    page-break-after: always;
  }
  #romaneio-print-papers .rmn-paper * { box-sizing: border-box; }
  #romaneio-print-papers .rmn-paper:last-child { page-break-after: auto; }
  @media print {
    #romaneio-print-papers .rmn-amb,
    #romaneio-print-papers .rmn-block { page-break-inside: avoid; }
  }
  `;
}
